import { render, staticRenderFns } from "./init_data_airtable.vue?vue&type=template&id=02a367d4"
import script from "./init_data_airtable.vue?vue&type=script&setup=true&lang=js"
export * from "./init_data_airtable.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports